import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { ThemeContext } from '../../theme';
import { useTheme } from '@emotion/react';

const Switch = (props) => {
  const context = useContext(ThemeContext);
  const theme = useTheme();
  let switchBtn;
  if (theme && theme.switchBtn) {
    switchBtn = theme.switchBtn;
  } else {
    switchBtn = context.theme.switchBtn;
  }
  const {
    isHandOnHover,
    switchOnLeverColor,
    switchOnBackground,
    switchOffLeverColor,
    switchOffBackground,
    switchDisabledLeverColor,
    switchDisabledBackground
  } = switchBtn;

  const {
    isSelected,
    isDisabled,
    onText,
    offText
  } = props;

  const styles = StyleSheet.create({
    switch: {
      userSelect: 'none'
    },
    label: {
      cursor: isHandOnHover ? 'pointer' : 'initial'
    },
    input: {
      opacity: '0',
      width: '0',
      height: '0'
    },
    lever: {
      display: 'inline-block',
      position: 'relative',
      width: '36px',
      height: '14px',
      borderRadius: '15px',
      marginRight: '10px',
      transition: 'background 0.3s ease',
      verticalAlign: 'middle',
      margin: '0 16px',
      background: switchOffBackground,
      ':before': {
        content: '""',
        position: 'absolute',
        display: 'inline-block',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        left: '0',
        top: '-3px',
        background: 'silver',
        transition: 'left 0.3s ease, background .3s ease, box-shadow 0.1s ease, transform .1s ease'
      },
      ':after': {
        content: '""',
        position: 'absolute',
        display: 'inline-block',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        left: '0',
        top: '-3px',
        background: switchOffLeverColor,
        boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
        transition: 'left 0.3s ease, background .3s ease, box-shadow 0.1s ease, transform .1s ease'
      }
    },
    selectedLever: {
      background: switchOnBackground,
      ':after': {
        left: '18px',
        background: switchOnLeverColor
      },
      ':before': {
        left: '18px'
      }
    },
    disabledLever: {
      cursor: 'not-allowed',
      background: switchDisabledBackground,
      ':before': {
        background: 'transparent'
      },
      ':after': {
        background: switchDisabledLeverColor
      }
    }
  });

  return (
    <div
      className={css(styles.switch)}
      onClick={(e) => { e.stopPropagation(); }}
    >
      <label
        className={css(styles.label)}
      >
        <input
          className={css(styles.input)}
          type='checkbox'
          checked={isSelected}
          disabled={isDisabled}
          onChange={props.onSelectionChanged}
        />
        <span
          className={css(
            styles.lever,
            isSelected && styles.selectedLever,
            isDisabled && styles.disabledLever
          )}
        />
        {isSelected ? onText : offText}
      </label>
    </div>
  );
};

Switch.propTypes = {
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onText: PropTypes.string,
  offText: PropTypes.string,
  onSelectionChanged: PropTypes.func
};

Switch.defaultProps = {
  isSelected: false,
  isDisabled: false,
  onText: 'On',
  offText: 'Off'
};

export { Switch };
